/** Engine policy shared by browser preferences and headless calculations. */
export type AutoSizeVdropTarget = 3 | 5;
export const DEFAULT_AUTO_SIZE_VDROP_TARGET: AutoSizeVdropTarget = 3;
